import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Input, InputNumber, Select, TextArea } from '@/ui';
import { Form, FormItem } from '@/components';

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1.5rem;
`;

export const StyledButton = styled(Button)`
  &&& {
    min-height: 2.5rem;
    width: 100%;
    border-color: transparent;
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledFormItemWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
`;

export const StyledFormItem = styled(FormItem)`
  width: 100%;
  margin-bottom: 0;

  &&& .ant-form-item-label {
    padding: 0;
    label {
      ${pickThemeFontStyles('12', '14', 'NORMAL')};
      color: ${COLORS.IRON_GRAY};
    }
  }
`;

export const StyledSelect = styled(Select)`
  min-height: 2.75rem;
`;

export const StyledTextArea = styled(TextArea)`
  min-height: 10rem !important;
`;

export const StyledInputNumber = styled(InputNumber)`
  min-height: 2.6rem;
  input {
    min-height: 2.6rem;
  }
`;

export const StyledInput = styled(Input)`
  min-height: 2.6rem;
  input {
    min-height: 2.6rem;
  }
`;
